import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CityService {
  constructor(private http:HttpClient) { }

  addCity(data:any){
    return this.http.post(environment.apiUrl + "city/addNew" , data)
  }

  getAllCity(data:any){
    return this.http.post(environment.apiUrl + "city/get/pagination" , data)
  }

  // verifyCityToggle(data:any){
  //   return this.http.post(environment.apiUrl + "city/update"  , data)
  // }

  // deleteCity(data:any){
  //   return this.http.post(environment.apiUrl + "city/update"  , data)
  // }

  updateCity(data:any){
    return this.http.post(environment.apiUrl + "city/update"  , data)
  }

  searchCity(data:any){
    return this.http.post(environment.apiUrl + "city/search"  , data)
  }

}
